import { Component, input } from '@angular/core';
import { HelpRequest } from '@shared/index';
import { SupervisorService } from '../supervisor.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-supervisor-notification',
  imports: [NgClass],
  templateUrl: './supervisor-notification.component.html'
})
export class SupervisorNotificationComponent {
  public readonly helpRequest = input.required<HelpRequest>();
  constructor(public supervisorService: SupervisorService) {

  }

  public toggleReadNotification() {
    this.supervisorService.solveUserNeedsHelp(this.helpRequest()._id, !this.helpRequest().solved);
  }
}
